import { trackEmailCaptured } from '@mc/pre-paywall-events'
import { getPageSource } from '@mc/track-event'

export const fireFooterEmailCapturedEvent = (email: string) => {
  trackEmailCaptured({
    event: 'Email Captured',
    properties: {
      email,
      type: 'email',
      platform: 'web',
      page_source: getPageSource(),
      location: 'global_footer',
    },
  })
}
